import { CategoryId } from '@business/entities/tm';
import { Endpoint } from '../endpoint';
import {
  CompactProviderResponse,
  ProviderCategoryRegionParams,
  ProviderSearchParams,
  ServiceProviderId,
  TmServiceProvidersResponse,
} from '@business/entities/tm/TmServiceProviderResponse';
import { R } from '@core/utils/r';
import { ServiceProviderFormData } from '@modules/settings/SettingsPage/Components/EstimateTab/AddEditServiceProviderModal/ProviderForm';
import { CategoryRegionProviderPriorityForm } from '@modules/settings/SettingsPage/Components/BillingTab/Tabs/CategoryTab/ManageProviderPriorityOverlay/ManageProviderPriorityOverlay';

export function fetchServiceProviders(query?: ProviderSearchParams) {
  const params = R.objectCompact(query);
  return Endpoint.get<CompactProviderResponse[]>(`@gc/service-providers`, { params });
}

export function fetchServiceProvider(id: ServiceProviderId) {
  return Endpoint.get<TmServiceProvidersResponse>(`@gc/service-providers/service-provider/${id}`);
}

export function createServiceProvider(data: ServiceProviderFormData) {
  return Endpoint.post<TmServiceProvidersResponse>(`@gc/service-providers`, { data });
}

export function updateServiceProvider(id: ServiceProviderId, data: ServiceProviderFormData) {
  return Endpoint.patch<TmServiceProvidersResponse>(`@gc/service-providers/${id}`, { data });
}

export function deleteServiceProvider(id: ServiceProviderId) {
  return Endpoint.delete<void>(`@gc/service-providers/${id}`);
}

export function fetchServiceProvidersBaseOnCategoryRegion(query?: ProviderCategoryRegionParams) {
  const params = R.objectCompact(query);
  return Endpoint.get<TmServiceProvidersResponse[]>(`@gc/service-providers/provider-base-on-category-region`, { params });
}
